<template>
  <td class="table-quicktag-cell">
    <!-- <ux-spinner v-if="processing" /> -->
    <!-- v-else -->
    <flex-row gap center>
      <!-- <flex-cell shrink>
        <ux-button icon size="xs">
          <ux-icon icon="fa-pen-to-square" />
        </ux-button>
      </flex-cell> -->
      <flex-cell>
        <ux-pill icon="fa-tag" tag="a" :value="tag" v-for="tag in tags" />
      </flex-cell>
    </flex-row>
    <div class="clicker" @click.stop.prevent="clicked" v-if="canEditItem">
      <flex-row gap center>
        <flex-cell> </flex-cell>
        <flex-cell shrink>
          <ux-button icon size="xs">
            <ux-icon icon="fa-pen-to-square" />
          </ux-button>
        </flex-cell>
      </flex-row>
    </div>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async clicked() {
      const self = this;
      // Open the modal to adjust tags

      const existingTags = (self.tags || []).slice();
      const newTags = await self.$sdk.tag({
        title: "Edit tags",
        description: self.row.title,
        model: existingTags.slice(),
      });

      const existingTagIDs = self.$sdk.utils.ids(existingTags);
      const newTagIDs = self.$sdk.utils.ids(newTags);
      const arraysEqual =
        JSON.stringify(existingTagIDs.sort()) ===
        JSON.stringify(newTagIDs.sort());

      if (!arraysEqual) {
        self.processing = true;
        await self.$sdk.content.patch(this.itemID, {
          meta: {
            tags: newTags,
          },
        });

        self.row.meta.tags = newTags;
        self.processing = false;

        self.$sdk.notify(`Tags were updated`);
      }
    },
  },
  computed: {
    canEditItem() {
      return this.$sdk.access.canEditItem(this.user, this.row);
    },
    itemID() {
      return this.row._id;
    },
    tags() {
      const row = this.row;
      const actualTags = row.meta?.tags || [];
      return actualTags;
    },
  },
};
</script>
<style scoped lang="scss">
td {
  position: relative;

  .clicker {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
    border-radius: 0.5em;
    opacity: 0;
    display: flex;
  }

  &:hover {
    .clicker {
      padding-right: 0.5em;
      opacity: 1;
      border: 1px solid color-mix(in lab, currentColor 10%, transparent);
    }
  }
}
</style>
